import type { ReactNode } from "react";
import styles from "./Keycap.module.css";

/**
 * 버튼에 표시하는 단축키 키캡이다.
 *
 * 접근성 이름에는 넣지 않는다. 스크린리더는 키캡이 아니라 라벨을 읽는다. 키캡은 키와 버튼의
 * 관계를 눈으로 보여 주는 장식이다. 배경이 진한 버튼(solid) 위에서는 기본 톤이 잘 보이지 않는다.
 * 그래서 호출부가 `className` 으로 색을 덮어쓴다.
 */
export function Keycap({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): ReactNode {
  return (
    <span
      className={className ? `${styles.keycap} ${className}` : styles.keycap}
      aria-hidden="true"
    >
      {children}
    </span>
  );
}
